export default "__VITE_ASSET__faa7393e__"